import { cn } from '@/lib/classNames';
import type { ComponentPropsWithoutRef } from 'react';

type TagChipProps = ComponentPropsWithoutRef<'span'> & {
	isActive?: boolean;
};

export const TagChip = ({ isActive, className, ...props }: TagChipProps) => (
	<span
		data-is-active={isActive}
		className={cn(
			'cursor-auto rounded-full border border-dm-grey bg-dm-black4 px-2 py-px text-sm text-dm-white transition-colors',
			'data-[is-active=true]:border-dm-gold data-[is-active=true]:bg-dm-gold data-[is-active=true]:text-dm-black1',
			className
		)}
		{...props}
	/>
);
